import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/home/index'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
      meta: {
        keepAlive: true
      }
    },
    {
      path: '/views/accurateSearch',
      name: 'accurateSearch',
      component: () =>
        import('@/views/accurateSearch/index'),
      meta: {
        keepAlive: false
      }
    },
    {
      path: '/views/optimizationSearch',
      name: 'optimizationSearch',
      component: () =>
        import('@/views/optimizationSearch/index'),
      meta: {
        keepAlive: false
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js